var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.646.646c.492-.146.617-.09.708 0A.5.5 0 0 1 5.5 1v3.5H9a.498.498 0 0 1 .354.854A.498.498 0 0 1 9 5.5H5.5V9a.498.498 0 0 1-.854.354A.498.498 0 0 1 4.5 9V5.5H1a.498.498 0 0 1-.354-.854A.498.498 0 0 1 1 4.5h3.5V1c0-.138.056-.263.146-.354Z",
    fill: "#D8D8D8",
    stroke: "#979797",
    fillRule: "evenodd"
  })));
};

export default SvgAdd;